import { render, staticRenderFns } from "./ProposalCertify.vue?vue&type=template&id=5fa3a402&"
import script from "./ProposalCertify.vue?vue&type=script&lang=js&"
export * from "./ProposalCertify.vue?vue&type=script&lang=js&"
import style0 from "./ProposalCertify.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports